/**
 * Spanish + English translation catalog.
 * Keys are namespaced (page.section.key). Missing keys fall back to the Spanish value.
 */

export const TRANSLATIONS = {
  es: {
    // ---------- Common / generic ----------
    "common.loading": "Cargando…",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.close": "Cerrar",
    "common.search": "Buscar",
    "common.signin": "Inicia sesión",
    "common.signup": "Crear una cuenta nueva",
    "common.signout": "Cerrar sesión",
    "common.menu": "Menú",
    "common.email": "Correo electrónico",
    "common.password": "Contraseña",
    "common.continue": "Continuar",
    "common.welcome": "Bienvenid@",
    "common.player": "Jugador",
    "common.admin": "Admin",

    // ---------- Header / Navigation ----------
    "nav.brand": "LA POLLA",
    "nav.brandSub": "Mundialista",
    "nav.timezone": "Zona horaria",
    "nav.timezone.help": "Aplica a todas las fechas / horas",
    "nav.language": "Idioma",
    "nav.profile": "Mi perfil",
    "nav.rules": "Reglas",
    "nav.phase1": "Fase 1 (Grupos)",
    "nav.phase2": "Fase 2 (Eliminación)",
    "nav.ranking": "Tabla de posiciones",
    "nav.realScores": "Marcadores reales y Pronósticos del grupo",
    "nav.allPicks": "Todos los pronósticos",
    "nav.news": "Noticias",
    "nav.specialPools": "Pollas Especiales",
    "footer.specialPools": "Especial",
    "special.title": "Pollas Especiales",
    "special.tabs.home": "Inicio",
    "special.tabs.prize": "Premio y pronósticos",
    "special.tabs.result": "Resultado y ganadores",
    "special.welcomeLabel": "Bienvenido a tu polla especial",
    "special.yourPick": "Tu pronóstico",
    "special.savePrediction": "Guardar pronóstico",
    "special.updatePrediction": "Actualizar pronóstico",
    "special.predictionSaved": "Pronóstico guardado",
    "special.locked": "Edición cerrada por el admin",
    "special.nickSaved": "Apodo actualizado",
    "special.rulesPdf.title": "Reglamento",
    "special.rulesPdf.subtitle": "Descarga las reglas oficiales",
    "special.prize.first": "1er puesto",
    "special.prize.second": "2do puesto",
    "special.prize.third": "3er puesto",
    "special.prize.splitHint": "El premio se reparte en partes iguales entre quienes acierten el marcador exacto.",
    "special.prize.empty": "El admin aún no ha definido un premio para esta polla.",
    "special.preds.lockedTitle": "Pronósticos privados",
    "special.preds.lockedSubtitle": "Cuando el admin cierre la edición verás aquí todos los pronósticos.",
    "special.preds.title": "Pronósticos de la polla",
    "special.preds.entries": "registros",
    "special.preds.empty": "Aún no hay pronósticos registrados.",
    "special.result.pendingTitle": "Resultado pendiente",
    "special.result.pendingSubtitle": "Cuando termine el partido el admin publicará el resultado oficial y los ganadores.",
    "special.result.official": "Resultado oficial",
    "special.result.winnersTitle": "Ganadores",
    "special.result.winnersCount": "ganadores",
    "special.result.noWinners": "Nadie acertó el marcador exacto.",
    "special.empty.title": "Aún no hay pollas especiales",
    "special.empty.body": "Cuando el admin cree una polla especial y te asigne un código, podrás participar aquí.",
    "special.errors.load": "No se pudo cargar la polla especial",
    "special.errors.scoreInvalid": "Marcador inválido",
    "err.save": "Error al guardar",
    "common.saving": "Guardando…",
    "common.cancel": "Cancelar",
    "common.back": "Volver",
    "profile.editNick": "Editar nombre o apodo",
    "nav.admin": "Admin",

    // ---------- Public menu (logged-out drawer) ----------
    "publicMenu.register": "Registrarme",
    "publicMenu.requiresLogin": "REQUIERE INICIAR SESIÓN",

    // ---------- Bottom nav ----------
    "footer.home": "Home",
    "footer.rules": "Reglas",
    "footer.predictions": "Pronósticos",
    "footer.ranking": "Tabla de posiciones",
    "footer.realScores": "Marcadores reales",

    // ---------- Notifications ----------
    "notifications.title": "Notificaciones",
    "notifications.empty": "No tienes notificaciones aún.",
    "notifications.count_one": "{count} evento",
    "notifications.count_other": "{count} eventos",
    "notifications.aria": "Notificaciones",
    "notifications.dismiss": "Eliminar notificación",
    "notifications.clearAll": "Borrar todas",

    // ---------- Login page ----------
    "login.kickerDefault": "FIFA WORLD CUP 2026",
    "login.lineDefault1": "Pronostica tus resultados,",
    "login.lineDefault2": "acierta los marcadores,",
    "login.lineDefault3": "sube en la tabla de posiciones",
    "login.lineDefault4": "y gánale a tus amigos y familiares.",
    "login.scrollHint": "Scroll",
    "login.welcomeBack": "INICIAR SESIÓN",
    "login.forgotPassword": "¿Olvidaste tu contraseña?",
    "login.continueWithGoogle": "Continuar con Google",
    "login.newUser": "¿Eres nuevo?",
    "login.noAccountYet": "Si aún no tienes cuenta",
    "login.needInvite": "Necesitarás un código de invitación del admin.",
    "login.haveAccount": "O, si ya tienes cuenta",
    "login.loginCta": "Iniciar sesión",
    "login.or": "O",
    "login.2faRequired": "Necesitas tu código 2FA para continuar",
    "login.2faTitle": "Verificación 2FA",
    "login.2faHint": "Abre tu app autenticadora (Google Authenticator, Authy…) e ingresa el código de 6 dígitos. También puedes usar un código de recuperación.",
    "login.2faCode": "Código 2FA",
    "login.2faSubmit": "Verificar",

    // ---------- Security (profile) ----------
    "security.section.title": "Seguridad",
    "security.section.subtitle": "Cuida tu cuenta cambiando la contraseña o activando la verificación en dos pasos.",
    "security.changePassword.title": "Cambiar contraseña",
    "security.changePassword.cta": "Cambiar contraseña",
    "security.changePassword.current": "Contraseña actual",
    "security.changePassword.new": "Nueva contraseña (mín. 8)",
    "security.changePassword.confirm": "Confirmar nueva contraseña",
    "security.changePassword.submit": "Actualizar",
    "security.changePassword.mismatch": "Las contraseñas nuevas no coinciden",
    "security.changePassword.tooShort": "La nueva contraseña debe tener al menos 8 caracteres",
    "security.changePassword.success": "Contraseña actualizada",
    "security.changePassword.googleOnly": "Tu cuenta usa Google. No tiene contraseña que cambiar.",
    "security.twoFactor.title": "Verificación en dos pasos (2FA)",
    "security.twoFactor.subtitle": "Solicita un código adicional al iniciar sesión.",
    "security.twoFactor.status.on": "Activado",
    "security.twoFactor.status.off": "Desactivado",
    "security.twoFactor.enable": "Activar 2FA",
    "security.twoFactor.disable": "Desactivar 2FA",
    "security.twoFactor.setup.step1": "1. Escanea este código QR con Google Authenticator, Authy, 1Password u otra app TOTP.",
    "security.twoFactor.setup.step2": "2. Ingresa el código de 6 dígitos que muestra la app.",
    "security.twoFactor.setup.secretLabel": "¿No puedes escanear? Ingresa esta clave manualmente:",
    "security.twoFactor.setup.codeInput": "Código de 6 dígitos",
    "security.twoFactor.setup.verify": "Verificar y activar",
    "security.twoFactor.setup.success": "2FA activado",
    "security.twoFactor.recovery.title": "Códigos de recuperación",
    "security.twoFactor.recovery.intro": "Guarda estos códigos en un lugar seguro. Cada uno se puede usar una sola vez para iniciar sesión si pierdes acceso a tu app autenticadora.",
    "security.twoFactor.recovery.copy": "Copiar todos",
    "security.twoFactor.recovery.copied": "Copiado",
    "security.twoFactor.recovery.done": "Listo",
    "security.twoFactor.disable.title": "Desactivar 2FA",
    "security.twoFactor.disable.intro": "Ingresa tu contraseña actual y un código 2FA (o código de recuperación) para deshabilitar la verificación en dos pasos.",
    "security.twoFactor.disable.password": "Contraseña actual",
    "security.twoFactor.disable.code": "Código 2FA o de recuperación",
    "security.twoFactor.disable.submit": "Desactivar",
    "security.twoFactor.disable.success": "2FA desactivado",

    // ---------- Register page ----------
    "register.kicker": "CREAR CUENTA",
    "register.titlePrefix": "Únete a",
    "register.titleHighlight": "La Polla",
    "register.subtitle": "Para inscribirte necesitas el código de invitación enviado por el admin.",
    "register.noCodeNotice": "¿Aún no tienes código? Contacta al administrador para que apruebe tu inscripción.",
    "register.codeLabel": "Código de invitación *",
    "register.codePlaceholder": "Ej. MUNDIAL26",
    "register.googleButton": "Registrarme con Google",
    "register.divider": "o con email",
    "register.nicknameLabel": "Nombre o apodo",
    "register.emailLabel": "Email",
    "register.passwordLabel": "Contraseña",
    "register.submit": "Crear cuenta",
    "register.haveAccount": "¿Ya tienes cuenta?",
    "register.signInLink": "Inicia sesión",
    "register.success": "Cuenta creada",
    "register.errors.nicknameShort": "El apodo debe tener al menos 3 caracteres",
    "register.errors.codeRequired": "Código de invitación requerido",
    "register.errors.generic": "Error",
    "auth.errors.invalidCredentials": "Credenciales inválidas",
    "auth.errors.emailExists": "Este correo ya está registrado",
    "auth.errors.nicknameInUse": "Ese apodo ya está en uso",
    "auth.errors.inviteRequired": "Necesitas un código de invitación. Solicítalo al administrador.",
    "auth.errors.inviteUsed": "Este código de invitación ya fue utilizado",
    "auth.errors.inviteInvalid": "Código de invitación inválido",
    "auth.errors.googleSessionInvalid": "Sesión de Google inválida. Intenta nuevamente.",
    "auth.errors.sessionRequired": "Se requiere session_id",
    "auth.googleNewUser": "Tu cuenta es nueva. Vuelve a la pantalla de inicio de sesión, ingresa tu código de invitación y luego presiona \"Continuar con Google\".",
    "auth.callback.title": "Conectando…",
    "auth.callback.subtitle": "Procesando inicio de sesión con Google",

    // ---------- Forgot password ----------
    "forgot.back": "Volver al inicio de sesión",
    "forgot.kicker": "RECUPERAR ACCESO",
    "forgot.title": "¿Olvidaste tu contraseña?",
    "forgot.subtitle": "Por el momento el reseteo automático por email no está habilitado. Contacta al administrador para recuperar tu acceso.",
    "forgot.contactLabel": "Escribe a",
    "forgot.mailSubject": "Recuperación de contraseña — La Polla Mundialista",
    "forgot.help": "Incluye en el correo el email con el que te registraste para que podamos verificar tu cuenta. Recibirás una contraseña temporal que podrás cambiar al iniciar sesión.",
    "forgot.rememberCta": "¿Ya te acordaste?",
    "login.cta": "Iniciar sesión",

    // ---------- Footer (public) ----------
    "footer.follow": "Síguenos",
    "footer.tagline": "Vive el mundial con nosotros",
    "footer.copyright": "© 2026 La Polla Mundialista",

    // ---------- Bell / Notifications types ----------
    "notif.type.news": "Nueva noticia",
    "notif.type.publish.groups": "Pronósticos de Fase 1 publicados",
    "notif.type.publish.body": "Ya puedes revisar los pronósticos de todos los participantes.",

    // ---------- Mi Perfil ----------
    "profile.kicker": "PERFIL",
    "profile.hello": "Hola,",
    "profile.editNickname": "Editar nombre o apodo",
    "profile.nicknameHelp": "Este es el nombre o apodo que se mostrará en el ranking público de la competición.",
    "profile.stats.points": "Puntos acumulados",
    "profile.stats.position": "Posición actual",
    "profile.stats.no": "No.",
    "profile.stats.phase1Picks": "Pronósticos Fase 1",
    "profile.stats.phase2Picks": "Pronósticos Fase 2",
    "profile.cta.news": "Noticias y actualizaciones",
    "profile.cta.rules": "Reglamento",
    "profile.cta.ranking": "Tabla de posiciones",
    "profile.cta.phase1": "Tus pronósticos Fase 1 (Grupos)",
    "profile.cta.phase1.sub": "Predice 72 partidos",
    "profile.cta.phase2": "Tus pronósticos Fase 2 (Eliminación directa)",
    "profile.cta.phase2.sub": "Predice 32 partidos adicionales",
    "profile.cta.realScores": "Marcadores reales y pronósticos del grupo",

    // ---------- Ranking ----------
    "ranking.title": "Tabla de posiciones",
    "ranking.subtitle": "El líder se actualiza en tiempo real con cada partido.",
    "ranking.colPos": "Pos",
    "ranking.colPlayer": "Jugador",
    "ranking.colPoints": "Puntos",
    "ranking.poolGeneral": "Polla general (todos)",
    "ranking.poolPrivate": "Tus pollas privadas",
    "ranking.empty": "Aún no hay participantes en esta polla.",
    "ranking.loading": "Calculando posiciones…",
    "ranking.you": "Tú",
    "ranking.prize.title": "Premio acumulado",

    // ---------- Reglas ----------
    "rules.title": "Reglas y reglamento",
    "rules.scoringHeader": "Sistema de puntuación",
    "rules.tiebreakerHeader": "Desempate",
    "rules.downloadPdf": "Descargar reglamento (PDF)",
    "rules.kicker": "REGLAMENTO",
    "rules.heading": "Reglas del juego",
    "rules.subheading": "La Polla Mundialista premia la precisión en tus pronósticos. Mira cómo se calcula tu puntaje.",
    "rules.section.points": "Puntos por partido",
    "rules.section.bonus": "Puntos Extra",
    "rules.section.lock": "Bloqueo de pronósticos",
    "rules.section.visibility": "Visibilidad de pronósticos",
    "rules.section.tiebreaker": "Desempate",
    "rules.pts": "PTS",
    "rules.pdf.title": "Más info",
    "rules.pdf.subtitle": "Reglamento completo en formato PDF.",
    "rules.pdf.download": "Descargar PDF",
    "rules.pdf.empty": "Aún no hay PDF cargado.",
    "rules.pdf.replace": "Reemplazar",
    "rules.pdf.upload": "Subir PDF",
    "rules.pdf.remove": "Quitar",
    "rules.pdf.removeConfirm": "¿Eliminar el PDF de reglas?",
    "rules.pdf.removed": "PDF eliminado",
    "rules.pdf.uploaded": "PDF cargado",
    "rules.pdf.onlyPdf": "Solo PDF",
    "rules.pdf.maxSize": "Máximo 15 MB",
    "rules.pdf.uploadError": "Error al subir PDF",
    "rules.pdf.removeError": "Error al eliminar",
    "rules.pdf.addAnother": "Agregar PDF",
    "rules.pdf.titlePlaceholder": "Título del PDF (p. ej. Reglamento, Premios…)",
    "rules.pdf.titleRequired": "El título no puede estar vacío",
    "rules.pdf.titleSaved": "Título actualizado",
    "rules.pdf.visibleIn": "Visible en",
    "rules.pdf.allPools": "Todas las pollas",
    "rules.edit.paraHelp": "Separa cada párrafo con una línea en blanco.",
    "rules.edit.saving": "Guardando…",
    "rules.edit.saved": "Texto actualizado",
    "rules.edit.tooltip": "Editar",

    // ---------- Fase 1 ----------
    "phase1.kicker": "SIMULADOR · FASE 1",
    "phase1.title": "Fase 1 — Grupos",
    "phase1.subtitle.fallback": "Ingresa el marcador de cada partido. La posición en cada grupo se calcula automáticamente. También elige tus picks de torneo (campeón, subcampeón, tercer puesto).",
    "phase1.published": "Pronósticos publicados. Ya no se pueden modificar.",
    "phase1.tabs.torneo": "Picks de Torneo",
    "phase1.tabs.todos": "Todos",
    "phase1.tabs.group": "Grupo {letter}",
    "phase1.allTitle": "Todos los partidos de Fase 1",
    "phase1.allCount": "{count} partidos · ordenados por fecha",
    "phase1.empty": "Sin partidos.",
    "phase1.picks.champion": "Campeón",
    "phase1.picks.runnerUp": "Subcampeón",
    "phase1.picks.third": "Tercer puesto",
    "phase1.picks.select": "— Selecciona —",
    "phase1.standings.team": "Equipo",
    "phase1.standings.pts": "PTS",
    "phase1.standings.gd": "DG",
    "phase1.standings.gf": "GF",

    // ---------- Fase 2 ----------
    "phase2.kicker": "SIMULADOR · FASE 2",
    "phase2.title": "Fase 2 — Eliminación directa",
    "phase2.subtitle.fallback": "Una vez que termine la fase de grupos, el administrador definirá qué equipos jugarán en cada partido de las eliminatorias. Aquí podrás pronosticar el marcador y el equipo ganador de cada llave, etapa por etapa.",
    "phase2.stages.r32": "16vos de final",
    "phase2.stages.r16": "Octavos de final",
    "phase2.stages.qf": "Cuartos de final",
    "phase2.stages.sf": "Semifinal",
    "phase2.stages.third": "Tercer puesto",
    "phase2.stages.final": "Final",
    "phase2.short.r32": "16vos",
    "phase2.short.r16": "8vos",
    "phase2.short.qf": "4tos",
    "phase2.short.sf": "Semis",
    "phase2.short.third": "3er Puesto",
    "phase2.short.final": "Final",
    "phase2.publishedBanner": "Pronósticos de {stage} publicados. Ya no se pueden modificar.",
    "phase2.progress": "{defined}/{total} partidos definidos por el admin en {stage}",
    "phase2.noMatches": "No hay partidos en esta etapa.",
    "phase2.tbd": "Por definir",
    "phase2.locked": "BLOQUEADO",
    "phase2.penalties.title": "Empate · ¿Quién pasa por penales?",
    "phase2.penalties.help": "Solo afecta el bracket — no suma puntos extra.",

    // ---------- Todos los Pronósticos ----------
    "todos.kicker": "FAIR PLAY",
    "todos.title": "Marcadores reales y Pronósticos del grupo",
    "todos.tabs.real": "Marcadores reales",
    "todos.legend.real": "Marcador real (oficial)",
    "todos.legend.mine": "Tu pronóstico",
    "todos.col.date": "Fecha / Hora",
    "todos.col.group": "Grupo",
    "todos.col.match": "Partido",
    "todos.col.real": "Marcador real",
    "todos.col.mine": "Tu pronóstico",
    "todos.col.city": "Ciudad",
    "todos.notPlayed": "Por jugarse",
    "todos.noPrediction": "Sin pronóstico",
    "todos.publishedOn": "Pronósticos de {stage} publicados el {date}",
    "todos.notPublishedYet": "Aún no se han publicado los pronósticos de {stage}. Estará disponible cuando el admin lo habilite.",
    "todos.excelHeader": "Excel · {stage}",
    "todos.excelHelp.available": "Descarga el archivo Excel con los pronósticos de los participantes de tu polla para la etapa de {stage}. Ya está disponible — haz clic abajo.",
    "todos.excelHelp.locked": "Descarga el archivo Excel con los pronósticos de los participantes de tu polla para la etapa de {stage}. Estará disponible cuando el admin publique esta etapa específica.",
    "todos.excelDownload": "Descargar Excel",
    "todos.excelLocked": "Aún bloqueado",
    "todos.excelLoading": "Cargando partidos…",

    // ---------- Noticias ----------
    "news.title": "Noticias",
    "news.empty": "Aún no hay noticias publicadas.",
    "news.readMore": "Leer más",
    "news.back": "Volver a noticias",
    "news.newsroom": "NEWSROOM",
    "news.new": "Nueva noticia",
    "news.cancel": "Cancelar",
    "news.titlePlaceholder": "Título",
    "news.imageLabel": "Imagen (opcional — si la dejas vacía se usará una aleatoria)",
    "news.uploadImage": "Subir imagen",
    "news.changeImage": "Cambiar imagen",
    "news.urlPlaceholder": "…o pega una URL de imagen",
    "news.urlPlaceholderShort": "…o pega una URL",
    "news.bodyPlaceholder": "Contenido",
    "news.publishing": "Publicando…",
    "news.publish": "Publicar",
    "news.published": "Noticia publicada",
    "news.publishError": "Error al publicar",
    "news.deleteConfirm": "¿Eliminar noticia?",
    "news.edit": "Editar",
    "news.delete": "Eliminar",
    "news.editModalTitle": "Editar noticia",
    "news.currentImage": "Imagen actual",
    "news.uploadNew": "Subir nueva imagen",
    "news.saveChanges": "Guardar cambios",
    "news.saving": "Guardando…",
    "news.saved": "Noticia actualizada",
    "news.saveError": "Error al actualizar",
    "news.imageTooLarge": "La imagen debe pesar menos de 8 MB",
    "news.imageMax": "Máximo 8 MB",
    "news.pickImage": "Selecciona un archivo de imagen",
    "news.pickImageShort": "Selecciona una imagen",
    "news.removeAria": "Quitar imagen",

    // ---------- Errors ----------
    "err.locked": "Bloqueado",
    "err.save": "Error al guardar",
  },

  en: {
    "common.loading": "Loading…",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.search": "Search",
    "common.signin": "Sign in",
    "common.signup": "Create a new account",
    "common.signout": "Sign out",
    "common.menu": "Menu",
    "common.email": "Email",
    "common.password": "Password",
    "common.continue": "Continue",
    "common.welcome": "Welcome",
    "common.player": "Player",
    "common.admin": "Admin",

    "nav.brand": "LA POLLA",
    "nav.brandSub": "Mundialista",
    "nav.timezone": "Time zone",
    "nav.timezone.help": "Applies to all dates / times",
    "nav.language": "Language",
    "nav.profile": "My profile",
    "nav.rules": "Rules",
    "nav.phase1": "Phase 1 (Groups)",
    "nav.phase2": "Phase 2 (Knockouts)",
    "nav.ranking": "Leaderboard",
    "nav.realScores": "Real scores & group predictions",
    "nav.allPicks": "All predictions",
    "nav.news": "News",
    "nav.specialPools": "Special Pools",
    "footer.specialPools": "Special",
    "special.title": "Special Pools",
    "special.tabs.home": "Home",
    "special.tabs.prize": "Prize & predictions",
    "special.tabs.result": "Result & winners",
    "special.welcomeLabel": "Welcome to your special pool",
    "special.yourPick": "Your pick",
    "special.savePrediction": "Save prediction",
    "special.updatePrediction": "Update prediction",
    "special.predictionSaved": "Prediction saved",
    "special.locked": "Editing closed by admin",
    "special.nickSaved": "Nickname updated",
    "special.rulesPdf.title": "Rulebook",
    "special.rulesPdf.subtitle": "Download the official rules",
    "special.prize.first": "1st place",
    "special.prize.second": "2nd place",
    "special.prize.third": "3rd place",
    "special.prize.splitHint": "The prize is split equally among everyone who guesses the exact score.",
    "special.prize.empty": "Admin hasn't set a prize for this pool yet.",
    "special.preds.lockedTitle": "Predictions are private",
    "special.preds.lockedSubtitle": "Once the admin closes editing, all predictions will appear here.",
    "special.preds.title": "Pool predictions",
    "special.preds.entries": "entries",
    "special.preds.empty": "No predictions registered yet.",
    "special.result.pendingTitle": "Result pending",
    "special.result.pendingSubtitle": "Once the match ends, the admin will publish the official result and winners.",
    "special.result.official": "Official result",
    "special.result.winnersTitle": "Winners",
    "special.result.winnersCount": "winners",
    "special.result.noWinners": "Nobody guessed the exact score.",
    "special.empty.title": "No special pools yet",
    "special.empty.body": "When the admin creates a special pool and assigns you a code, you'll join it here.",
    "special.errors.load": "Could not load the special pool",
    "special.errors.scoreInvalid": "Invalid score",
    "err.save": "Save failed",
    "common.saving": "Saving…",
    "common.cancel": "Cancel",
    "common.back": "Back",
    "profile.editNick": "Edit name or nickname",
    "nav.admin": "Admin",

    // ---------- Public menu (logged-out drawer) ----------
    "publicMenu.register": "Sign up",
    "publicMenu.requiresLogin": "REQUIRES SIGN-IN",

    "footer.home": "Home",
    "footer.rules": "Rules",
    "footer.predictions": "Predictions",
    "footer.ranking": "Leaderboard",
    "footer.realScores": "Real scores",

    "notifications.title": "Notifications",
    "notifications.empty": "You have no notifications yet.",
    "notifications.count_one": "{count} event",
    "notifications.count_other": "{count} events",
    "notifications.aria": "Notifications",
    "notifications.dismiss": "Dismiss notification",
    "notifications.clearAll": "Clear all",

    "login.kickerDefault": "FIFA WORLD CUP 2026",
    "login.lineDefault1": "Predict your results,",
    "login.lineDefault2": "guess the scores,",
    "login.lineDefault3": "climb the leaderboard",
    "login.lineDefault4": "and beat your friends and family.",
    "login.scrollHint": "Scroll",
    "login.welcomeBack": "SIGN IN",
    "login.forgotPassword": "Forgot your password?",
    "login.continueWithGoogle": "Continue with Google",
    "login.newUser": "New here?",
    "login.noAccountYet": "If you don't have an account yet",
    "login.needInvite": "You'll need an invitation code from the admin.",
    "login.haveAccount": "Or, if you already have an account",
    "login.loginCta": "Sign in",
    "login.or": "Or",
    "login.2faRequired": "We need your 2FA code to continue",
    "login.2faTitle": "2FA verification",
    "login.2faHint": "Open your authenticator app (Google Authenticator, Authy…) and enter the 6-digit code. You can also use a recovery code.",
    "login.2faCode": "2FA code",
    "login.2faSubmit": "Verify",

    // ---------- Security (profile) ----------
    "security.section.title": "Security",
    "security.section.subtitle": "Protect your account by changing your password or enabling two-factor authentication.",
    "security.changePassword.title": "Change password",
    "security.changePassword.cta": "Change password",
    "security.changePassword.current": "Current password",
    "security.changePassword.new": "New password (min. 8)",
    "security.changePassword.confirm": "Confirm new password",
    "security.changePassword.submit": "Update",
    "security.changePassword.mismatch": "New passwords don't match",
    "security.changePassword.tooShort": "New password must be at least 8 characters",
    "security.changePassword.success": "Password updated",
    "security.changePassword.googleOnly": "Your account uses Google sign-in. There's no password to change.",
    "security.twoFactor.title": "Two-factor authentication (2FA)",
    "security.twoFactor.subtitle": "Require an extra code when signing in.",
    "security.twoFactor.status.on": "Enabled",
    "security.twoFactor.status.off": "Disabled",
    "security.twoFactor.enable": "Enable 2FA",
    "security.twoFactor.disable": "Disable 2FA",
    "security.twoFactor.setup.step1": "1. Scan this QR code with Google Authenticator, Authy, 1Password or any other TOTP app.",
    "security.twoFactor.setup.step2": "2. Enter the 6-digit code shown by the app.",
    "security.twoFactor.setup.secretLabel": "Can't scan? Enter this key manually:",
    "security.twoFactor.setup.codeInput": "6-digit code",
    "security.twoFactor.setup.verify": "Verify & enable",
    "security.twoFactor.setup.success": "2FA enabled",
    "security.twoFactor.recovery.title": "Recovery codes",
    "security.twoFactor.recovery.intro": "Save these codes somewhere safe. Each one can be used once to sign in if you lose access to your authenticator app.",
    "security.twoFactor.recovery.copy": "Copy all",
    "security.twoFactor.recovery.copied": "Copied",
    "security.twoFactor.recovery.done": "Done",
    "security.twoFactor.disable.title": "Disable 2FA",
    "security.twoFactor.disable.intro": "Enter your current password and a 2FA code (or recovery code) to turn off two-factor authentication.",
    "security.twoFactor.disable.password": "Current password",
    "security.twoFactor.disable.code": "2FA or recovery code",
    "security.twoFactor.disable.submit": "Disable",
    "security.twoFactor.disable.success": "2FA disabled",

    // ---------- Register page ----------
    "register.kicker": "CREATE ACCOUNT",
    "register.titlePrefix": "Join",
    "register.titleHighlight": "La Polla",
    "register.subtitle": "You need the invite code sent by the admin to sign up.",
    "register.noCodeNotice": "Don't have a code yet? Contact the administrator to approve your registration.",
    "register.codeLabel": "Invite code *",
    "register.codePlaceholder": "e.g. WORLDCUP26",
    "register.googleButton": "Sign up with Google",
    "register.divider": "or with email",
    "register.nicknameLabel": "Name or nickname",
    "register.emailLabel": "Email",
    "register.passwordLabel": "Password",
    "register.submit": "Create account",
    "register.haveAccount": "Already have an account?",
    "register.signInLink": "Sign in",
    "register.success": "Account created",
    "register.errors.nicknameShort": "Nickname must be at least 3 characters",
    "register.errors.codeRequired": "Invite code required",
    "register.errors.generic": "Error",
    "auth.errors.invalidCredentials": "Invalid credentials",
    "auth.errors.emailExists": "This email is already registered",
    "auth.errors.nicknameInUse": "That nickname is already taken",
    "auth.errors.inviteRequired": "You need an invite code. Please request one from the administrator.",
    "auth.errors.inviteUsed": "This invite code has already been used",
    "auth.errors.inviteInvalid": "Invalid invite code",
    "auth.errors.googleSessionInvalid": "Invalid Google session. Please try again.",
    "auth.errors.sessionRequired": "session_id is required",
    "auth.googleNewUser": "Your account is new. Return to the sign-in screen, enter your invite code and then press \"Continue with Google\".",
    "auth.callback.title": "Connecting…",
    "auth.callback.subtitle": "Processing your Google sign-in",

    // ---------- Forgot password ----------
    "forgot.back": "Back to sign in",
    "forgot.kicker": "RECOVER ACCESS",
    "forgot.title": "Forgot your password?",
    "forgot.subtitle": "Automatic email reset is not enabled yet. Contact the administrator to recover your access.",
    "forgot.contactLabel": "Write to",
    "forgot.mailSubject": "Password recovery — La Polla Mundialista",
    "forgot.help": "Include in the email the address you used to register so we can verify your account. You will receive a temporary password you can change after signing in.",
    "forgot.rememberCta": "Did you remember?",
    "login.cta": "Sign in",

    "footer.follow": "Follow us",
    "footer.tagline": "Live the World Cup with us",
    "footer.copyright": "© 2026 La Polla Mundialista",

    "notif.type.news": "Latest news",
    "notif.type.publish.groups": "Phase 1 predictions published",
    "notif.type.publish.body": "You can now review every participant's predictions.",

    // ---------- Profile ----------
    "profile.kicker": "PROFILE",
    "profile.hello": "Hello,",
    "profile.editNickname": "Edit name or nickname",
    "profile.nicknameHelp": "This is the name or nickname shown in the public leaderboard.",
    "profile.stats.points": "Cumulative points",
    "profile.stats.position": "Current position",
    "profile.stats.no": "No.",
    "profile.stats.phase1Picks": "Phase 1 predictions",
    "profile.stats.phase2Picks": "Phase 2 predictions",
    "profile.cta.news": "News & updates",
    "profile.cta.rules": "Rules",
    "profile.cta.ranking": "Leaderboard",
    "profile.cta.phase1": "Your Phase 1 predictions (Groups)",
    "profile.cta.phase1.sub": "Predict 72 matches",
    "profile.cta.phase2": "Your Phase 2 predictions (Knockouts)",
    "profile.cta.phase2.sub": "Predict 32 additional matches",
    "profile.cta.realScores": "Real scores & group predictions",

    // ---------- Ranking ----------
    "ranking.title": "Leaderboard",
    "ranking.subtitle": "Updated live with every match result.",
    "ranking.colPos": "Pos",
    "ranking.colPlayer": "Player",
    "ranking.colPoints": "Points",
    "ranking.poolGeneral": "General pool (everyone)",
    "ranking.poolPrivate": "Your private pools",
    "ranking.empty": "No participants yet in this pool.",
    "ranking.loading": "Calculating positions…",
    "ranking.you": "You",
    "ranking.prize.title": "Accumulated prize",

    // ---------- Rules ----------
    "rules.title": "Rules",
    "rules.scoringHeader": "Scoring system",
    "rules.tiebreakerHeader": "Tiebreaker",
    "rules.downloadPdf": "Download rules (PDF)",
    "rules.kicker": "RULES",
    "rules.heading": "Game rules",
    "rules.subheading": "La Polla Mundialista rewards prediction accuracy. See how your points are calculated.",
    "rules.section.points": "Match points",
    "rules.section.bonus": "Bonus points",
    "rules.section.lock": "Prediction lock",
    "rules.section.visibility": "Prediction visibility",
    "rules.section.tiebreaker": "Tiebreaker",
    "rules.pts": "PTS",
    "rules.pdf.title": "More info",
    "rules.pdf.subtitle": "Full rulebook in PDF format.",
    "rules.pdf.download": "Download PDF",
    "rules.pdf.empty": "No PDF uploaded yet.",
    "rules.pdf.replace": "Replace",
    "rules.pdf.upload": "Upload PDF",
    "rules.pdf.remove": "Remove",
    "rules.pdf.removeConfirm": "Remove the rules PDF?",
    "rules.pdf.removed": "PDF removed",
    "rules.pdf.uploaded": "PDF uploaded",
    "rules.pdf.onlyPdf": "PDF only",
    "rules.pdf.maxSize": "Max 15 MB",
    "rules.pdf.uploadError": "Upload error",
    "rules.pdf.removeError": "Remove error",
    "rules.pdf.addAnother": "Add PDF",
    "rules.pdf.titlePlaceholder": "PDF title (e.g. Rulebook, Prizes…)",
    "rules.pdf.titleRequired": "Title cannot be empty",
    "rules.pdf.titleSaved": "Title updated",
    "rules.pdf.visibleIn": "Visible in",
    "rules.pdf.allPools": "All pools",
    "rules.edit.paraHelp": "Separate each paragraph with a blank line.",
    "rules.edit.saving": "Saving…",
    "rules.edit.saved": "Text updated",
    "rules.edit.tooltip": "Edit",

    // ---------- Phase 1 ----------
    "phase1.kicker": "SIMULATOR · PHASE 1",
    "phase1.title": "Phase 1 — Groups",
    "phase1.subtitle.fallback": "Enter the score for each match. The group standings are calculated automatically. Also pick your tournament selections (champion, runner-up, third place).",
    "phase1.published": "Predictions published. They can no longer be modified.",
    "phase1.tabs.torneo": "Tournament Picks",
    "phase1.tabs.todos": "All",
    "phase1.tabs.group": "Group {letter}",
    "phase1.allTitle": "All Phase 1 matches",
    "phase1.allCount": "{count} matches · sorted by date",
    "phase1.empty": "No matches.",
    "phase1.picks.champion": "Champion",
    "phase1.picks.runnerUp": "Runner-up",
    "phase1.picks.third": "Third place",
    "phase1.picks.select": "— Select —",
    "phase1.standings.team": "Team",
    "phase1.standings.pts": "PTS",
    "phase1.standings.gd": "GD",
    "phase1.standings.gf": "GF",

    // ---------- Phase 2 ----------
    "phase2.kicker": "SIMULATOR · PHASE 2",
    "phase2.title": "Phase 2 — Knockouts",
    "phase2.subtitle.fallback": "Once the group stage ends, the admin will set the teams playing each knockout match. Here you can predict the score and winner of each fixture, stage by stage.",
    "phase2.stages.r32": "Round of 32",
    "phase2.stages.r16": "Round of 16",
    "phase2.stages.qf": "Quarter-finals",
    "phase2.stages.sf": "Semi-finals",
    "phase2.stages.third": "Third place",
    "phase2.stages.final": "Final",
    "phase2.short.r32": "R32",
    "phase2.short.r16": "R16",
    "phase2.short.qf": "QF",
    "phase2.short.sf": "SF",
    "phase2.short.third": "3rd",
    "phase2.short.final": "Final",
    "phase2.publishedBanner": "{stage} predictions published. They can no longer be modified.",
    "phase2.progress": "{defined}/{total} matches set by admin in {stage}",
    "phase2.noMatches": "No matches in this stage.",
    "phase2.tbd": "TBD",
    "phase2.locked": "LOCKED",
    "phase2.penalties.title": "Draw · Who advances on penalties?",
    "phase2.penalties.help": "Only affects the bracket — no bonus points.",

    // ---------- Real scores / All predictions ----------
    "todos.kicker": "FAIR PLAY",
    "todos.title": "Real scores & group predictions",
    "todos.tabs.real": "Real scores",
    "todos.legend.real": "Real score (official)",
    "todos.legend.mine": "Your prediction",
    "todos.col.date": "Date / Time",
    "todos.col.group": "Group",
    "todos.col.match": "Match",
    "todos.col.real": "Real score",
    "todos.col.mine": "Your prediction",
    "todos.col.city": "City",
    "todos.notPlayed": "Not played",
    "todos.noPrediction": "No prediction",
    "todos.publishedOn": "{stage} predictions published on {date}",
    "todos.notPublishedYet": "{stage} predictions are not published yet. Will be available when the admin enables this stage.",
    "todos.excelHeader": "Excel · {stage}",
    "todos.excelHelp.available": "Download the Excel file with every participant's predictions for {stage}. It is available now — click below.",
    "todos.excelHelp.locked": "Download the Excel file with every participant's predictions for {stage}. Will be available when the admin publishes this stage.",
    "todos.excelDownload": "Download Excel",
    "todos.excelLocked": "Still locked",
    "todos.excelLoading": "Loading matches…",

    // ---------- News ----------
    "news.title": "News",
    "news.empty": "No news posted yet.",
    "news.readMore": "Read more",
    "news.back": "Back to news",
    "news.newsroom": "NEWSROOM",
    "news.new": "New post",
    "news.cancel": "Cancel",
    "news.titlePlaceholder": "Title",
    "news.imageLabel": "Image (optional — random if empty)",
    "news.uploadImage": "Upload image",
    "news.changeImage": "Change image",
    "news.urlPlaceholder": "…or paste an image URL",
    "news.urlPlaceholderShort": "…or paste a URL",
    "news.bodyPlaceholder": "Content",
    "news.publishing": "Publishing…",
    "news.publish": "Publish",
    "news.published": "News published",
    "news.publishError": "Publish error",
    "news.deleteConfirm": "Delete news?",
    "news.edit": "Edit",
    "news.delete": "Delete",
    "news.editModalTitle": "Edit news",
    "news.currentImage": "Current image",
    "news.uploadNew": "Upload new image",
    "news.saveChanges": "Save changes",
    "news.saving": "Saving…",
    "news.saved": "News updated",
    "news.saveError": "Update error",
    "news.imageTooLarge": "Image must be smaller than 8 MB",
    "news.imageMax": "Max 8 MB",
    "news.pickImage": "Pick an image file",
    "news.pickImageShort": "Pick an image",
    "news.removeAria": "Remove image",

    // ---------- Errors ----------
    "err.locked": "Locked",
    "err.save": "Save error",
  },
};

export const LANGUAGE_OPTIONS = [
  { id: "es", label: "Español", emoji: "🇪🇸" },
  { id: "en", label: "English", emoji: "🇺🇸" },
];
